import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { postRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import CustomAlert from '../../components/CustomAlert';
import RedIconSVG from '../SVG/RedIconSVG';;
import CloseIcon from '../SVG/CloseIcon';
import { reloadContactList, reloadContactOverview } from '../../store/actions/reduxAction';

const ContactDeleteList = (props) => {
  const {
    modalDeleteShow,
    setModalDeleteShow,
    selectedContactList,
    access_token,
    reloadContactList,
    reloadContactOverview,
  } = props;
  const [deleteContact, setDeleteContact] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  useEffect(() => {
    if (modalDeleteShow === true) {
      setSelectedContacts(selectedContactList);
    }
  }, [modalDeleteShow]);

  const handleSave = () => {

    const data = {
      lead_list_id: selectedContactList.id,
    };

    postRequest('/v2/contacts-delete-list', data, access_token.token, (res) => {
      if (res.success) {
        // Handle success if needed
        reloadContactList();
        reloadContactOverview();
        handleDeleteConfirmClose();
        setAlertState({
          message: `The "${selectedContactList.name}" contact list has been successfully deleted. `,
          show: true,
          variant: 'success',
        });
      } else {
        setAlertState({
          message: `Sorry, There was an error deleting "${selectedContactList.name}"`,
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  const handleDeleteConfirmClose = () => {
    setModalDeleteShow(false);
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal
        show={modalDeleteShow}
        className="modal-delete"
        animation={true}
        onHide={handleDeleteConfirmClose}
        centered
      >
        <Modal.Body>
          <CloseIcon handleModalClose={handleDeleteConfirmClose} />
          <RedIconSVG />

          <Modal.Title as="h4" style={{ margin: '16px 0 8px' }}>
            Delete “{selectedContacts?.name || ''}”
          </Modal.Title>
          <p>
            Are you sure you want to delete this contact list?
            <br />
            This will delete all the contacts in this list!
            <br />
            This action cannot be undone!
          </p>
          <div className="d-flex justify-content-center" style={{ marginTop: 24, gap: 16 }}>
            <Button
              variant="outline-secondary"
              onClick={handleDeleteConfirmClose}
              style={{ minWidth: 160 }}
            >
              Cancel
            </Button>
            <Button variant="danger" style={{ minWidth: 160 }} onClick={handleSave}>
              Confirm
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  const { access_token, user } = state.auth;

  return {
    access_token,
    user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  reloadContactList: () => dispatch(reloadContactList()),
  reloadContactOverview: () => dispatch(reloadContactOverview()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactDeleteList);
